/* TCR AI Parts Finder — deterministic Q&A knowledge base.
   Batch 1: 20 curated entries. Batch 2 (2026-10-04): 60 entries mined
   from the 10 buying guides + news articles. All answers grounded in
   source content — no fabricated specs. */
window.TCR_AI_KNOWLEDGE = [
{
    id: 'oil-which',
    patterns: ['what oil', 'which oil', 'what kind of oil', 'what type of oil', 'oil weight', 'oil viscosity', 'what motor oil'],
    answer: 'The right oil depends on your engine — always check your owner\'s manual for the exact viscosity (like 5W-30) and spec first. As a rule of thumb, most modern trucks and Jeeps run full synthetic 5W-30 or 0W-20. Full synthetic protects better under heat and towing loads than conventional.',
    products: 'full synthetic motor oil',
    chips: ['Motor oil', 'Oil filters']
  },
  {
    id: 'oil-synthetic-vs-conventional',
    patterns: ['synthetic vs conventional', 'synthetic or conventional', 'conventional vs synthetic', 'difference between synthetic and conventional'],
    answer: 'Full synthetic oil uses more refined base stocks: it flows better when cold, resists breakdown under heat and towing, and allows longer change intervals. Conventional is cheaper but breaks down faster. For trucks that tow or work hard, synthetic is the safer bet.',
    products: 'full synthetic motor oil',
    chips: ['Motor oil', 'Oil filters']
  },
  {
    id: 'oil-change-interval',
    patterns: ['how often', 'oil change interval', 'when to change oil', 'oil change frequency'],
    answer: 'With full synthetic, most manufacturers recommend every 7,500–10,000 miles — but severe use (towing, dusty trails, short trips) cuts that roughly in half. Your owner\'s manual and oil-life monitor are the final word.',
    products: 'motor oil',
    chips: ['Oil filters', 'Shop supplies']
  },
  {
    id: 'brakes-drilled-vs-slotted',
    patterns: ['drilled vs slotted', 'slotted vs drilled', 'drilled or slotted', 'difference between drilled and slotted'],
    answer: 'Drilled rotors run cooler and resist fade — good for street performance. Slotted rotors wipe the pad surface clean for a stronger bite — popular for towing and off-road. Drilled-and-slotted combines both. For a daily-driven truck, quality blank or slotted rotors with good pads are usually the sweet spot.',
    products: 'brake rotors',
    chips: ['Brake pads', 'Brake kits']
  },
  {
    id: 'brakes-when-replace',
    patterns: ['when to replace brake pads', 'brake pad wear', 'how long do brake pads last', 'signs of worn brakes', 'squeaking brakes', 'grinding brakes'],
    answer: 'Replace pads when they\'re down to about 3–4mm of material, or if you hear squealing (wear indicator) or grinding (metal on metal — don\'t wait on that). Most pads last 30,000–70,000 miles depending on driving and load. If the rotors are grooved or pulsing when you brake, have them measured too.',
    products: 'brake pads',
    chips: ['Brake rotors', 'Brake kits']
  },
  {
    id: 'intake-benefits',
    patterns: ['cold air intake benefits', 'what does a cold air intake do', 'is a cold air intake worth it', 'cold air intake vs stock'],
    answer: 'A cold air intake replaces the restrictive factory airbox with a freer-flowing filter and tube, pulling in cooler, denser air. Expect slightly better throttle response and a more aggressive intake sound; power gains are modest on their own (typically single-digit horsepower) but they pair well with exhaust and tuning.',
    products: 'cold air intake',
    chips: ['Air filters', 'Exhaust']
  },
  {
    id: 'tonneau-types',
    patterns: ['tonneau cover types', 'soft vs hard tonneau', 'which tonneau cover', 'roll up vs folding tonneau', 'best tonneau cover'],
    answer: 'Soft roll-ups are affordable, light, and easy to use — great daily drivers. Hard folding covers add security and a cleaner look. Retractable covers are the premium option: secure and convenient, at a higher price. Tell me your truck and bed length and I\'ll show you what fits.',
    products: 'tonneau cover',
    chips: ['Tonneau covers', 'Bed liners']
  },
  {
    id: 'fitment-will-it-fit',
    patterns: ['will this fit', 'does it fit my', 'fit my truck', 'fitment', 'compatible with my'],
    answer: 'Fitment depends on your exact year, make, model — and often cab and bed size for trucks. Tell me your vehicle (e.g. "2021 F-150") plus the part you\'re eyeing, and I\'ll pull up matching options. When in doubt, check the manufacturer\'s application notes on the product page before ordering.',
    chips: ['Brake pads', 'Tonneau covers', 'Cold air intakes']
  },
  {
    id: 'lift-vs-level',
    patterns: ['lift kit vs leveling kit', 'leveling kit vs lift', 'should i lift or level', 'what is a leveling kit'],
    answer: 'A leveling kit raises the front to match the rear (usually 1–2") — cheap, keeps factory ride, fits slightly bigger tires. A lift kit raises the whole truck 3"+ for real clearance and bigger tires, but costs more and changes handling. If you just want the stance, level it. If you need clearance for trails, lift it.',
    products: 'leveling kit',
    chips: ['Lift kits', 'Shocks']
  },
  {
    id: 'led-vs-halogen',
    patterns: ['led vs halogen', 'led or halogen', 'are led headlights better', 'difference between led and halogen'],
    answer: 'LEDs are brighter, whiter, last far longer, and draw less power than halogens. The catch: cheap LED drop-ins can scatter light and blind oncoming traffic — quality housings or complete LED assemblies aimed correctly are the right way to upgrade.',
    products: 'LED headlights',
    chips: ['Headlights', 'Light bars']
  },
  {
    id: 'shipping-time',
    patterns: ['how long does shipping take', 'shipping time', 'when will my order arrive', 'delivery time', 'how fast is shipping'],
    answer: 'Most in-stock orders ship within 1–2 business days. Transit time depends on your location and the shipping method you pick at checkout — you\'ll see the estimated dates before you pay. Orders over $200 ship free.',
    chips: ['Track my order']
  },
  {
    id: 'free-shipping',
    patterns: ['free shipping', 'do you offer free shipping', 'shipping cost'],
    answer: 'Yes — free shipping on all orders over $200. Under that, rates are calculated at checkout based on weight and destination.',
    chips: []
  },
  {
    id: 'returns',
    patterns: ['return policy', 'can i return', 'how do i return', 'refund policy', 'exchange policy'],
    answer: 'Unused parts in original packaging can be returned — check our Shipping & Returns page for the full policy and time window. If a part arrived damaged or wrong, reach out with your order number and we\'ll make it right.',
    chips: []
  },
  {
    id: 'track-order',
    patterns: ['track my order', 'where is my order', 'order status', 'tracking number'],
    answer: 'You\'ll get a tracking number by email as soon as your order ships. Check your inbox (and spam folder) for the shipping confirmation, or log into your account to see order status.',
    chips: []
  },
  {
    id: 'where-located',
    patterns: ['where are you located', 'where is your store', 'your address', 'do you have a physical store'],
    answer: 'We\'re based in Los Angeles, CA and ship across the US. We\'re primarily an online store — the full catalog lives right here on the site.',
    chips: []
  },
  {
    id: 'trade-pricing',
    patterns: ['trade pricing', 'bulk pricing', 'shop discount', 'mechanic discount', 'wholesale', 'business account', 'fleet pricing'],
    answer: 'We work with repair shops, race teams, and fleets — if you buy in volume, reach out through our contact page with your business details and what you typically order, and we\'ll talk trade pricing.',
    products: 'shop supplies',
    chips: ['Motor oil', 'Brake cleaner']
  },
  {
    id: 'warranty',
    patterns: ['warranty', 'do parts have warranty', 'guarantee'],
    answer: 'Warranty coverage comes from the manufacturer and varies by brand and part — check the product page or the brand\'s site for the exact terms on what you\'re buying. If a part fails under its warranty, we\'ll help you with the claim process.',
    chips: []
  },
  {
    id: 'install-difficulty',
    patterns: ['how hard to install', 'is it hard to install', 'can i install it myself', 'installation difficulty', 'diy install'],
    answer: 'It depends on the part: filters, wipers, and tonneau covers are easy driveway jobs; brakes and suspension are intermediate (basic tools + jack stands); internal engine work is best left to a shop. If you\'re unsure, a local shop can usually knock it out in an hour or two of labor.',
    chips: []
  },
  {
    id: 'price-match',
    patterns: ['price match', 'do you match prices', 'found it cheaper'],
    answer: 'We keep our pricing sharp across 105,000+ parts. If you\'ve found the identical part number cheaper elsewhere, send us the details through the contact page and we\'ll take a look.',
    chips: []
  },
  {
    id: 'payment-methods',
    patterns: ['what payment', 'payment methods', 'do you accept paypal', 'do you accept apple pay', 'financing'],
    answer: 'We accept all major credit cards, PayPal, Apple Pay, Google Pay, and Shop Pay (which offers installment plans at checkout).',
    chips: []
  },
/* ---------- AIR INTAKES ---------- */
  {
    id: 'intake-sealed-vs-open',
    patterns: ['sealed vs open intake', 'sealed or open intake', 'open element vs cold air', 'sealed cold air intake', 'open element intake'],
    answer: 'A sealed intake isolates the filter from engine-bay heat with a box or heat shield — the pick when intake air temperature matters. An open-element cone filter is louder, cheaper, and installs in about 30 minutes, but can pull warm underhood air at idle. Choose sealed for consistent performance, open for maximum sound on a budget.',
    products: 'cold air intake',
    chips: ['Air filters', 'Cold air intakes']
  },
  {
    id: 'intake-oiled-vs-dry-filter',
    patterns: ['oiled vs dry filter', 'oiled or dry air filter', 'dry vs oiled intake filter', 'k&n oiled filter vs dry'],
    answer: 'Oiled cotton-gauze filters (like K&N) are washable and reusable but need careful re-oiling — too much oil can foul the mass airflow sensor. Dry synthetic media (like aFe Pro Dry S) washes clean with no oiling step and no sensor risk. Filter choice rarely changes peak power, so pick by maintenance habit and how dusty your driving is.',
    products: 'air filter',
    chips: ['Cold air intakes', 'Air filters']
  },
  {
    id: 'intake-need-tune',
    patterns: ['do i need a tune with intake', 'intake require tune', 'cold air intake tune required', 'tune after intake install'],
    answer: 'Most street intakes are engineered to run on the factory calibration — no tune needed. Kits that significantly change the MAF housing diameter may require one, and the product page will say so. When in doubt, check the manufacturer\'s notes for your exact engine before ordering.',
    products: 'cold air intake',
    chips: ['Cold air intakes', 'Exhaust']
  },
  {
    id: 'mods-factory-warranty',
    patterns: ['will intake void warranty', 'will exhaust void warranty', 'will lift void warranty', 'aftermarket parts void warranty', 'void my factory warranty'],
    answer: 'A manufacturer can\'t void your warranty over an aftermarket part unless they prove that part caused the failure — that applies to intakes, exhausts, and lifts alike. Keep your stock parts in the garage in case of a dispute. Unrelated warranty claims are unaffected.',
    chips: ['Cold air intakes', 'Lift kits']
  },

  /* ---------- BRAKES ---------- */
  {
    id: 'brakes-pad-compounds',
    patterns: ['ceramic vs semi-metallic', 'ceramic or semi metallic pads', 'types of brake pads', 'best brake pad material', 'severe duty brake pads'],
    answer: 'Ceramic pads are quiet, low-dust, and long-lived — the best daily-driver choice. Semi-metallic pads bite harder and tolerate more heat, with more dust and noise. Severe-duty compounds are formulated for towing, big tires, and mountain grades where heat is the enemy. Match the compound to how you actually drive.',
    products: 'brake pads',
    chips: ['Brake pads', 'Brake rotors']
  },
  {
    id: 'brakes-big-brake-kit-worth-it',
    patterns: ['are big brake kits worth it', 'big brake kit vs stock', 'when to get big brake kit', 'do i need big brakes'],
    answer: 'Big brake kits — larger rotors with multi-piston calipers — earn their price on track cars, heavy tow rigs, and big-tire builds where stock brakes genuinely overheat. The larger diameter adds leverage and thermal mass that fights fade. For a stock daily driver they\'re overkill; quality pads and rotors are the smarter money.',
    products: 'big brake kit',
    chips: ['Brake kits', 'Brake rotors']
  },
  {
    id: 'brakes-stainless-lines',
    patterns: ['stainless brake lines', 'braided brake lines worth it', 'stainless steel brake hoses', 'firmer brake pedal lines'],
    answer: 'Braided stainless lines replace rubber hoses that swell under pressure, giving a firmer, more consistent pedal. They\'re also smart insurance on any lifted truck whose stock lines are stretched tight. Line replacement needs careful bleeding — use a shop if you\'re not confident doing it yourself.',
    products: 'brake lines',
    chips: ['Brake pads', 'Brake fluid']
  },
  {
    id: 'brakes-bedding-squeal',
    patterns: ['new brakes squealing', 'brakes squeak after install', 'how to bed brakes', 'brake bedding procedure', 'new pads squealing'],
    answer: 'New-brake squeal is usually improper bedding, missing hardware, or glazed pads — not defective parts. Always bed new pads exactly per the manufacturer\'s break-in procedure, use fresh hardware with proper lubricant, and give the pads a few heat cycles to seat. Persistent grinding means metal-on-metal: stop driving and inspect.',
    products: 'brake pads',
    chips: ['Brake rotors', 'Brake hardware']
  },
  {
    id: 'brakes-pads-on-stock-rotors',
    patterns: ['pads on stock rotors', 'just upgrade pads', 'pads without new rotors', 'can i keep my rotors'],
    answer: 'Yes — if your rotors are flat, thick enough, and not deeply scored, pads alone are the best bang-for-buck brake upgrade there is. Always replace rotors in axle pairs when you do swap them, and respect the minimum thickness spec stamped on the rotor.',
    products: 'brake pads',
    chips: ['Brake rotors', 'Brake kits']
  },
  {
    id: 'brakes-rotor-replacement-signs',
    patterns: ['how to know rotors need replacement', 'signs of bad rotors', 'warped rotors symptoms', 'brake pedal pulsation', 'when to replace rotors'],
    answer: 'Pedal pulsation under braking, deep scoring, visible cracks, or thickness below the minimum spec all mean new rotors. Pulsation is the classic tell — the rotors are telling you something. Measure with a micrometer rather than guessing.',
    products: 'brake rotors',
    chips: ['Brake pads', 'Brake kits']
  },
  {
    id: 'brakes-race-compounds',
    patterns: ['racing brake pads', 'track brake pads', 'best pads for track days', 'hawk brake pads', 'race pad compound'],
    answer: 'Racing pads are built around friction stability at temperature — the right compound stays predictable lap after lap instead of fading. Match the compound to your event, vehicle weight, and rotor temperature: more aggressive pads bite harder but wear rotors faster, dust more, and need heat to work. A pad is part of a system — consider bias, fluid, and cooling too.',
    products: 'racing brake pads',
    chips: ['Brake rotors', 'Brake fluid']
  },
  {
    id: 'brakes-fluid-dot',
    patterns: ['dot 3 vs dot 4', 'dot 4 vs dot 5.1', 'which brake fluid', 'can i mix dot 5', 'brake fluid types'],
    answer: 'DOT 3, DOT 4, and DOT 5.1 have different boiling points — use what your vehicle specifies or better. Brake fluid absorbs moisture over time, which lowers its boiling point, so flush it on schedule. Never mix DOT 5 silicone fluid with DOT 3/4/5.1 systems.',
    products: 'brake fluid',
    chips: ['Brake pads', 'Brake lines']
  },

  /* ---------- EXHAUST ---------- */
  {
    id: 'exhaust-catback-vs-axleback',
    patterns: ['cat back vs axle back', 'catback or axleback', 'what is a cat-back exhaust', 'axle back exhaust worth it', 'difference catback axleback'],
    answer: 'A cat-back replaces everything behind the catalytic converters — mid-pipe, muffler, tailpipes — and is the sweet spot for sound plus bolt-on install. An axle-back is just muffler and tailpipes: the simplest, cheapest exhaust upgrade, often under an hour in the driveway. Both leave emissions equipment alone.',
    products: 'cat-back exhaust',
    chips: ['Cat-back exhaust', 'Mufflers']
  },
  {
    id: 'exhaust-drone-avoid',
    patterns: ['exhaust drone', 'what is drone exhaust', 'how to avoid exhaust drone', 'drone at highway speed', 'exhaust too loud highway'],
    answer: 'Drone is low-frequency resonance at cruising RPM — the thing that ruins a daily driver. Systems with resonators or chambered mufflers control it best; straight-through race designs are the worst offenders. If it\'s a daily, prioritize drone control over maximum volume and listen to clips of the exact system on your engine first.',
    products: 'cat-back exhaust',
    chips: ['Mufflers', 'Exhaust resonators']
  },
  {
    id: 'exhaust-stainless-vs-aluminized',
    patterns: ['stainless vs aluminized exhaust', 'stainless or aluminized', 'is stainless exhaust worth it', 'aluminized steel exhaust rust'],
    answer: 'Stainless steel resists corrosion far longer — worth the premium in road-salt country or for a truck you\'ll keep for years. Aluminized steel costs less but has a shorter life in harsh climates. Both flow the same when new; you\'re buying longevity, not power.',
    products: 'cat-back exhaust',
    chips: ['Cat-back exhaust', 'Mufflers']
  },
  {
    id: 'exhaust-x-pipe-what',
    patterns: ['what does an x-pipe do', 'x-pipe vs h-pipe', 'x pipe exhaust benefits', 'do i need an x-pipe'],
    answer: 'An X-pipe joins the left and right banks of a dual exhaust so pressure pulses share volume downstream. On many V8s that smooths the note and improves scavenging versus two isolated pipes, with a more aggressive, higher-frequency character. Match the crossover size to the rest of your tubing — forcing a smaller X into a 3-inch system can become a restriction.',
    products: 'x-pipe',
    chips: ['Exhaust', 'Headers']
  },
  {
    id: 'exhaust-resonator-vs-muffler',
    patterns: ['resonator vs muffler', 'what does a resonator do', 'do i need a resonator', 'resonator for rasp', 'ultra quiet resonator'],
    answer: 'A muffler does broad noise reduction; a resonator targets specific harsh frequencies — rasp and drone — while keeping the system\'s flow and character. It\'s the fix when an exhaust sounds clean at full throttle but booms at cruise, or when short mufflers and aggressive cams add metallic rasp. Match the resonator inlet/outlet to your tubing size.',
    products: 'exhaust resonator',
    chips: ['Mufflers', 'Cat-back exhaust']
  },
  {
    id: 'exhaust-muffler-types-sound',
    patterns: ['chambered vs straight through muffler', 'turbo muffler vs chambered', 'muffler types sound', 'which muffler sounds best', 'flowmaster vs magnaflow style'],
    answer: 'Chambered mufflers give that classic deep, throaty muscle-car tone and control drone well. Straight-through designs flow the most and scream at full throttle but drone more on the highway. Turbo-style splits the difference — mellow at cruise, aggressive when you get on it. Pick your tone, then match inlet/outlet diameter and offset to your piping.',
    products: 'performance muffler',
    chips: ['Mufflers', 'Cat-back exhaust']
  },

  /* ---------- HEADERS ---------- */
  {
    id: 'headers-long-tube-vs-shorty',
    patterns: ['long tube vs shorty headers', 'longtube or shorty', 'shorty headers vs long tube', 'which headers should i get'],
    answer: 'Long-tube headers make the most power — the choice for serious builds, but they need a matching mid-pipe, often a tune, and a full day to install. Shorties bolt to your factory mid-pipe and cats, install far easier, and stay emissions-friendly — the smart street pick. Mid-length splits the difference with better ground clearance.',
    products: 'headers',
    chips: ['Headers', 'Cat-back exhaust']
  },
  {
    id: 'headers-materials-coatings',
    patterns: ['stainless vs ceramic headers', 'ceramic coated headers worth it', 'painted vs stainless headers', 'header materials'],
    answer: 'Stainless steel is the corrosion champion — lasts for years in salt country with no coating needed, costs more up front. Ceramic coating keeps heat in the tubes for lower underhood temps and better exhaust velocity, but quality depends on prep, so buy reputable makers. Painted mild steel is cheapest and makes the same power initially, but surface rust starts fast.',
    products: 'headers',
    chips: ['Headers', 'Exhaust gaskets']
  },
  {
    id: 'headers-emissions-legal',
    patterns: ['are headers street legal', 'headers emissions legal', 'long tube headers emissions', 'will headers pass inspection'],
    answer: 'It depends on your state and the design. Shorty headers that retain the factory catalytic converters are the safe street answer in inspection states. Long-tubes that relocate or remove cats may be race/off-road use only where you live. Check your state\'s emissions laws before buying — not after.',
    products: 'shorty headers',
    chips: ['Headers', 'Catalytic converters']
  },
  {
    id: 'headers-gaskets-install-tips',
    patterns: ['header gasket tips', 'headers leaking', 're-torque header bolts', 'header install tips', 'header bolts keep loosening'],
    answer: 'Always use new, quality header gaskets — never reuse crusty manifold hardware — and re-torque the bolts after a few heat cycles. Most header leaks are installation issues, not header issues. Soak every manifold bolt with penetrating oil the night before, and have a plan for broken studs.',
    products: 'exhaust gaskets',
    chips: ['Headers', 'Exhaust hardware']
  },

  /* ---------- LIGHTING ---------- */
  {
    id: 'lighting-spot-vs-flood',
    patterns: ['spot vs flood light bar', 'spot or flood', 'light bar beam pattern', 'combo vs spot light bar'],
    answer: 'Spot beams throw a tight pattern far down the trail — best for open, fast terrain. Flood beams light a wide area close in — best for slow technical work and camp setup. Most drivers are happiest with a combo bar, or a spot bar paired with flood pods. Ignore raw lumen marketing and look at candela and beam distance from reputable brands.',
    products: 'LED light bar',
    chips: ['Light bars', 'LED pods']
  },
  {
    id: 'lighting-hyperflash-fix',
    patterns: ['led turn signals blink fast', 'hyperflash fix', 'led blinker hyperflash', 'turn signals flashing fast after led'],
    answer: 'That fast blinking is hyperflash — the flasher expects the resistance of an incandescent bulb. Fix it with an LED-compatible flasher or load resistors wired in. Mount resistors on metal away from plastic, since they get hot.',
    products: 'LED turn signals',
    chips: ['LED bulbs', 'Load resistors']
  },
  {
    id: 'lighting-led-bulb-legal',
    patterns: ['are led headlight bulbs legal', 'led bulb legality', 'dot approved led headlights', 'led headlights street legal'],
    answer: 'It depends on the bulb, the housing, and your state. Complete DOT-compliant LED assemblies are the safe street choice with a proper beam pattern. Cheap drop-in bulbs in reflector housings can scatter light and blind oncoming traffic — check your local regulations before buying.',
    products: 'LED headlights',
    chips: ['Headlight assemblies', 'LED bulbs']
  },
  {
    id: 'lighting-relay-required',
    patterns: ['do i need a relay for light bar', 'relay for auxiliary lights', 'wiring relay fog lights', 'light bar wiring harness'],
    answer: 'Yes — always wire auxiliary lights through a relay and fused circuit. The relay lets a small dash switch safely control the high-current circuit, and the fuse protects the wiring. Skipping the relay and wiring straight to thin factory wire is how electrical fires start. Budget for a proper harness with relay, fuse, and switch.',
    products: 'light bar wiring harness',
    chips: ['Light bars', 'LED pods']
  },
  {
    id: 'lighting-assembly-vs-bulb',
    patterns: ['led assembly vs bulb', 'complete led headlights vs bulbs', 'are led drop in bulbs good', 'headlight assembly upgrade'],
    answer: 'Complete LED assemblies give the best beam pattern because the optics are engineered around the LED projectors. Drop-in bulbs are the budget path — pick designs that place the emitters exactly where the halogen filament sat, and check CAN-bus compatibility on newer trucks to avoid flicker and bulb-out warnings.',
    products: 'LED headlight assemblies',
    chips: ['LED bulbs', 'Headlight assemblies']
  },

  /* ---------- OIL & FLUIDS (deeper) ---------- */
  {
    id: 'oil-switch-to-synthetic',
    patterns: ['switch from conventional to synthetic', 'can i switch to synthetic oil', 'synthetic oil causes leaks myth', 'change to synthetic oil'],
    answer: 'Yes — switching from conventional to synthetic is safe in any engine. The old stories about synthetics causing leaks are myths. Make the switch at your next oil change and keep following your manual\'s viscosity and interval.',
    products: 'full synthetic motor oil',
    chips: ['Motor oil', 'Oil filters']
  },
  {
    id: 'oil-viscosity-numbers',
    patterns: ['what does 5w-30 mean', 'oil numbers meaning', 'what is viscosity grade', '5w30 vs 10w30', 'oil weight numbers explained'],
    answer: 'In 5W-30, the first number is cold-flow (winter) performance and the second is viscosity at operating temperature. Your engine\'s clearances, VVT system, and oil pump were designed around a specific grade — use exactly what the manual calls for rather than going thicker "for protection."',
    products: 'motor oil',
    chips: ['Motor oil', 'Oil filters']
  },
  {
    id: 'oil-brand-vs-spec',
    patterns: ['is expensive oil worth it', 'does oil brand matter', 'best oil brand', 'cheap vs expensive motor oil'],
    answer: 'What matters is meeting your manual\'s specification — viscosity, API category, dexos or other approvals — not the logo on the bottle. Any major-brand oil meeting spec protects your engine. Spend the savings on changing it on time with a quality filter.',
    products: 'motor oil',
    chips: ['Motor oil', 'Oil filters']
  },
  {
    id: 'oil-high-mileage-seals',
    patterns: ['high mileage oil worth it', 'oil for 100k miles', 'high mileage oil seal conditioner', 'oil for older engine leaks'],
    answer: 'High-mileage formulas add seal conditioners and extra detergents for engines over about 75,000 miles. The conditioners can help weepy gaskets seep less — but they won\'t fix a genuinely failed seal. That needs a wrench, not a bottle.',
    products: 'high mileage motor oil',
    chips: ['Motor oil', 'Oil filters']
  },
  {
    id: 'oil-additives-help',
    patterns: ['do oil additives work', 'should i use oil additives', 'oil additive for engine noise', 'lucas oil additive'],
    answer: 'Quality motor oils already contain a carefully balanced additive package — aftermarket additives can upset that chemistry and do more harm than good. Fix mechanical problems with parts, not bottles.',
    products: 'motor oil',
    chips: ['Motor oil', 'Engine treatment']
  },
  {
    id: 'fluids-transmission-fluid-picky',
    patterns: ['which transmission fluid', 'atf type matters', 'wrong transmission fluid symptoms', 'transmission fluid specification'],
    answer: 'Modern automatic transmissions are extremely picky — use exactly the fluid the transmission calls for. The wrong ATF causes shift problems that feel like a failing transmission. When in doubt, the owner\'s manual spec wins over any universal-fluid claim.',
    products: 'transmission fluid',
    chips: ['Transmission fluid', 'Transmission filters']
  },
  {
    id: 'fluids-coolant-mixing',
    patterns: ['can i mix coolant types', 'coolant types explained', 'oat vs hoat coolant', 'which coolant for my truck', 'mixing green and orange coolant'],
    answer: 'Match the coolant chemistry (OAT, HOAT, etc.) to what\'s already in the system. Mixing incompatible types as a shortcut causes sludge and corrosion inside the cooling system. When switching types, flush thoroughly first.',
    products: 'coolant antifreeze',
    chips: ['Coolant', 'Thermostats']
  },

  /* ---------- SEATS ---------- */
  {
    id: 'seats-reclinable-vs-fixed-back',
    patterns: ['reclinable vs fixed back seats', 'racing seats for daily driver', 'fixed bucket vs sport seat', 'are racing seats comfortable daily'],
    answer: 'Reclinable sport seats are the call for a street car — real bolstering with the adjustability a daily driver needs, and they work with factory seatbelts. Fixed-back buckets are for track and race cars: maximum support and minimum weight, but punishing on long drives. Be honest about your driving mix before choosing.',
    products: 'racing seats',
    chips: ['Sport seats', 'Seat brackets']
  },
  {
    id: 'seats-harness-rollbar-safety',
    patterns: ['harness without roll bar', 'racing harness safety', 'do i need a roll bar with harness', 'harness bar vs roll cage'],
    answer: 'A harness without a roll bar or cage is dangerous — in a rollover you need the structure the harness assumes, and you should never mount a harness to the floor since the angles matter. Harnesses belong with fixed-back seats, proper mounting points, and rollover protection as a complete system. For street cars, a good sport seat with the factory three-point belt is the safe setup.',
    products: 'racing harness',
    chips: ['Racing seats', 'Roll bars']
  },
  {
    id: 'seats-brackets-sliders',
    patterns: ['seat brackets for my car', 'do i need seat brackets', 'universal seat bracket', 'seat sliders vs fixed mount'],
    answer: 'Budget for vehicle-specific brackets and sliders — they\'re half the purchase. Vehicle-specific brackets bolt to factory mounting points with no fabrication; universal-fit promises usually mean custom work. Sliders add adjustment while fixed mounts save weight and sit lower. Tall drivers should check seat height, since some combos sit higher than stock.',
    products: 'seat brackets',
    chips: ['Racing seats', 'Seat sliders']
  },
  {
    id: 'seats-side-airbags',
    patterns: ['aftermarket seats airbag light', 'do racing seats have airbags', 'seat swap airbag warning', 'replacing seats with side airbags'],
    answer: 'Factory seats often contain side airbags — replacing them disables that protection and will likely trigger a warning light. Know what you\'re giving up before ordering, and check whether your setup needs a resistor or module to keep the rest of the SRS system happy.',
    products: 'racing seats',
    chips: ['Sport seats', 'Seat brackets']
  },

  /* ---------- SUSPENSION ---------- */
  {
    id: 'susp-body-lift-vs-suspension',
    patterns: ['body lift vs suspension lift', 'is a body lift worth it', 'body lift kit pros cons', 'body lift or suspension lift'],
    answer: 'A body lift uses pucks to raise the body off the frame — cheap tire clearance, but zero improvement in ground clearance under the frame or axles and no suspension benefit. It works as a small add-on to a suspension lift, not instead of one. For real capability, buy the suspension kit.',
    products: 'suspension lift kit',
    chips: ['Lift kits', 'Leveling kits']
  },
  {
    id: 'susp-alignment-after-lift',
    patterns: ['do i need alignment after lift', 'alignment after leveling kit', 'align truck after lifting'],
    answer: 'Yes, always. Changed ride height changes alignment angles, and driving misaligned chews through expensive tires fast. Budget for a professional alignment immediately after any lift or leveling kit install.',
    products: 'lift kit',
    chips: ['Lift kits', 'Shocks']
  },
  {
    id: 'susp-ride-quality-change',
    patterns: ['will a lift ruin ride quality', 'does lifting truck make ride worse', 'lift kit ride quality', 'rough ride after lift'],
    answer: 'A quality complete kit with properly matched shocks can ride as well as stock — sometimes better. Cheap spacer lifts and mismatched shocks are what ride rough. If daily comfort matters, buy the complete engineered system once instead of the cheap kit twice.',
    products: 'suspension lift kit',
    chips: ['Lift kits', 'Shocks']
  },
  {
    id: 'susp-shocks-matched',
    patterns: ['shocks for lifted truck', 'do i need new shocks with lift', 'best shocks for lift kit', 'match shocks to lift'],
    answer: 'Every lifted truck needs damping matched to its new springs, tires, and lift height — stock-length shocks on a lifted truck top out and ride terribly. Match shock length and valving to your lift; adjustable or remote-reservoir units are worth it for trucks that work hard off-road or tow heavy.',
    products: 'lift kit shocks',
    chips: ['Shocks', 'Lift kits']
  },
  {
    id: 'susp-lowering-cut-springs',
    patterns: ['lowering kit vs cut springs', 'can i cut my springs', 'lowering springs worth it', 'drop kit for truck'],
    answer: 'Buy engineered drop springs, spindles, or flip kits — never cut stock springs. Cut springs have unpredictable rates, can unseat over bumps, and handle dangerously. A proper lowering kit keeps spring rates and geometry sane for street performance and stance.',
    products: 'lowering kit',
    chips: ['Lowering kits', 'Shocks']
  },
  {
    id: 'susp-offroad-damping-travel',
    patterns: ['offroad suspension setup', 'best suspension for overlanding', 'desert truck suspension', 'shocks for washboard roads', 'truck bucks on washboard'],
    answer: 'Off-road control comes from damping, usable wheel travel, spring rate, and geometry — not just lift height. On fast rough terrain, quality shocks managing heat are the difference between control and repeated bottom-outs; on rocks, articulation and tire contact matter most. A spacer lift adds clearance without adding travel or damping, so be honest about speed and weight when choosing.',
    products: 'offroad shocks',
    chips: ['Shocks', 'Lift kits']
  },

  /* ---------- TONNEAU COVERS (deeper) ---------- */
  {
    id: 'tonneau-fuel-economy-myth',
    patterns: ['tonneau cover gas mileage', 'do tonneau covers save gas', 'tonneau cover fuel economy', 'mpg with tonneau cover'],
    answer: 'Some owners report small fuel-economy gains from reduced drag, but it\'s modest — buy a cover for security and weather protection, not mileage claims. The real payoff is keeping tools and cargo dry and out of sight.',
    products: 'tonneau cover',
    chips: ['Tonneau covers', 'Bed liners']
  },
  {
    id: 'tonneau-diy-install',
    patterns: ['can i install tonneau cover myself', 'tonneau cover install time', 'tonneau cover no drill install', 'how hard to install tonneau'],
    answer: 'Most clamp-on covers install with hand tools in under an hour and no drilling. Retractable covers take longer because the canister needs careful alignment. If you have a drop-in bed liner, check the fitment notes — liners can interfere with clamp placement on some trucks.',
    products: 'tonneau cover',
    chips: ['Tonneau covers', 'Bed liners']
  },
  {
    id: 'tonneau-waterproof-leak',
    patterns: ['are tonneau covers waterproof', 'do tonneau covers leak', 'tonneau cover rain leak', 'waterproof truck bed cover'],
    answer: 'No cover is perfectly waterproof. Good designs channel water away with seals and drainage tubes — expect minor drips in a real downpour. If keeping the bed bone-dry matters, look at hard folding or retractable designs with full-perimeter sealing.',
    products: 'tonneau cover',
    chips: ['Tonneau covers', 'Bed liners']
  },
  {
    id: 'tonneau-bed-length-fitment',
    patterns: ['how to measure truck bed', 'what bed length do i have', 'tonneau cover bed size', '5.5 vs 6.5 bed'],
    answer: 'Bed length is the number-one tonneau fitment mistake. Measure your bed or check the build sheet — 5.5 ft, 6.5 ft, and 8 ft beds take different covers, and cab configuration matters too. Always buy for your exact year, make, model, cab, and bed length.',
    products: 'tonneau cover',
    chips: ['Tonneau covers']
  },

  /* ---------- WHEELS ---------- */
  {
    id: 'wheels-cast-flowformed-forged',
    patterns: ['cast vs forged wheels', 'flow formed vs forged', 'cast vs flow formed wheels', 'are forged wheels worth it', 'wheel construction types'],
    answer: 'Cast wheels are the affordable street standard — buy established brands with real load ratings. Flow-formed wheels spin-stretch the barrel for extra strength and less weight at mid-range prices. Forged wheels compress a solid billet for the highest strength-to-weight ratio — the pick for heavy towing rigs and track cars where failure isn\'t an option.',
    products: 'wheels',
    chips: ['Wheels', 'Lug nuts']
  },
  {
    id: 'wheels-steel-winter-set',
    patterns: ['steel wheels for winter', 'winter wheel setup', 'steelies vs alloys winter', 'cheap winter wheels'],
    answer: 'Stamped steel wheels are the smart dedicated winter set — cheap, tough, and a bent one can often be hammered back into service. They keep road salt off your nice alloys. They\'re heavy, but for a winter beater set that\'s the right tradeoff.',
    products: 'steel wheels',
    chips: ['Wheels', 'TPMS sensors']
  },
  {
    id: 'wheels-offset-explained',
    patterns: ['what is wheel offset', 'wheel offset explained', 'offset vs backspacing', 'wrong offset rubbing'],
    answer: 'Offset is how far the mounting face sits from the wheel\'s centerline — it decides where the wheel sits in the well. Wrong offset causes rubbing on suspension or fenders, and big brake kits need extra clearance. Get bolt pattern, hub bore, and offset right before falling in love with a style.',
    products: 'wheels',
    chips: ['Wheels', 'Wheel spacers']
  },
  {
    id: 'wheels-lug-nuts-seat',
    patterns: ['do i need new lug nuts', 'lug nut seat types', 'tuner lug nuts', 'aftermarket wheels lug nuts'],
    answer: 'Often yes — aftermarket wheels frequently need a different seat type (conical, ball, or flat) or tuner-style nuts to clear the lug holes. Never reuse the wrong seat type; it won\'t seat properly and can loosen. Grab the right nuts with the wheels.',
    products: 'lug nuts',
    chips: ['Wheels', 'Lug nuts']
  },
  {
    id: 'wheels-tpms-sensors',
    patterns: ['tpms with new wheels', 'do i need new tpms sensors', 'transfer tpms sensors', 'tpms relearn new wheels'],
    answer: 'You\'ll need to transfer your existing sensors or buy new ones with the wheels — factor sensors plus a relearn procedure into the budget. Skipping it means a permanent dash light.',
    products: 'TPMS sensors',
    chips: ['Wheels', 'TPMS sensors']
  },

  /* ---------- FROM NEWS ARTICLES ---------- */
  {
    id: 'tires-drag-radial-vs-slick',
    patterns: ['drag radial vs slick', 'drag radials or slicks', 'best tires for drag racing', 'drag racing tires street strip'],
    answer: 'Drag radials are the right starting point for street-and-strip cars — DOT-approved, stable on the road, and they need less burnout than slicks. Full slicks are for dedicated drag cars: the soft compound and wrinkling sidewall maximize launch traction but give up street manners. Match the tire to weight, power, and how the car leaves, not just what fits under it.',
    products: 'drag radial tires',
    chips: ['Drag tires', 'Wheels']
  },
  {
    id: 'diff-gear-ratio-basics',
    patterns: ['what gear ratio should i get', '3.73 vs 4.10 gears', 'differential gear ratio explained', 'higher gear ratio faster', 'what do gears do'],
    answer: 'A numerically higher ratio (4.10 vs 3.55) multiplies torque harder at the tires — snappier launches and better response for heavy vehicles — at the cost of higher cruise RPM and more fuel burn. Lower ratios cruise easier but can feel lazy, especially with big tires. It\'s a system decision: engine powerband, tire diameter, transmission gearing, and weight all matter.',
    products: 'ring and pinion gears',
    chips: ['Differentials', 'Gear sets']
  },
  {
    id: 'diff-truetrac-vs-locker',
    patterns: ['truetrac vs locker', 'detroit truetrac vs detroit locker', 'helical vs clutch limited slip', 'best limited slip differential'],
    answer: 'A helical-gear limited slip (like the Detroit Truetrac) biases torque to the gripping tire with no clutch packs to wear out and no ratcheting noise — great for hard street use and corner exit. A full locker mechanically ties both axles together for maximum traction off-road, with harsher street manners. Match the carrier to your axle, spline count, and gear set first.',
    products: 'limited slip differential',
    chips: ['Differentials', 'Axle shafts']
  },
  {
    id: 'fuel-pump-not-always-pump',
    patterns: ['fuel pump keeps failing', 'fuel pump no prime', 'fuel pump loses pressure', 'fuel pump diagnosis', 'car dies at wide open throttle fuel'],
    answer: 'A pump that quits at full throttle or won\'t prime isn\'t always a bad pump — check fuel pressure under load with a real gauge before replacing anything. Weak relays, corroded grounds, clogged filters, tank debris, and low voltage create identical symptoms. Replacing the pump without finding the root cause turns one failed part into an expensive repeat repair.',
    products: 'fuel pump',
    chips: ['Fuel pumps', 'Fuel filters']
  },
  {
    id: 'carb-too-big-too-small',
    patterns: ['carburetor too big symptoms', 'what size carb do i need', 'carb cfm for 350', 'too big carburetor lazy'],
    answer: 'A carb that\'s too large makes a healthy engine feel lazy off the line; too small becomes a restriction past peak torque. Size by displacement, cam timing, intake manifold, converter or clutch, gearing, weight, and intended RPM — not by ordering the biggest CFM number. The carb works as part of the complete air-and-fuel package.',
    products: 'carburetor',
    chips: ['Carburetors', 'Intake manifolds']
  },
  {
    id: 'wiring-load-plan-relays',
    patterns: ['race car wiring', 'how to wire a race car', 'wiring harness relays fuses', 'car electrical keeps failing'],
    answer: 'Plan a race or project-car harness as a system: list every electrical load with its current draw, then give each branch its own fused position and relays where current is high. Protect every circuit, minimize connections, and make faults easy to find — a fuel-pump fuse that opens in the staging lanes should be a two-minute diagnosis, not a mystery.',
    products: 'wiring harness',
    chips: ['Relays', 'Fuse blocks']
  },
  {
    id: 'paint-2k-aerosol-clear',
    patterns: ['2k clear coat aerosol', 'spray can clear coat', '2k vs 1k clear', 'aerosol clearcoat for bumper'],
    answer: 'A 2K aerosol clear uses a separate hardener activated before spraying, giving a cured film with far better chemical resistance, hardness, and durability than basic 1K air-dry clears. It\'s ideal for small panels, repairs, and fabricated parts where a spray gun is overkill. Surface prep is non-negotiable, and wear a proper respirator — catalyzed urethanes are serious chemistry.',
    products: '2K clear coat',
    chips: ['Paint', 'Body supplies']
  },
  {
    id: 'greeting-hi',
    patterns: ['hi', 'hello', 'hey', 'good morning', 'good afternoon', 'good evening', 'howdy', 'hi there', 'hello there'],
    answer: 'Hi! Great to see you. I can answer questions about parts, fitment, shipping and more — or help you find the right part for your vehicle. What are you looking for?',
    chips: ['Brake pads', 'What oil should I use?', 'Do you offer free shipping?']
  },
  {
    id: 'who-are-you',
    patterns: ['who are you', 'what are you', 'your name', 'what is this', 'what can you do', 'how do you work'],
    answer: 'I\'m the AI Parts Finder — Turbochargedracing\'s parts assistant. Ask me a question (like "what\'s the difference between drilled and slotted rotors?") or tell me what you need (like "brake pads for 2021 F-150") and I\'ll help you find it.',
    chips: ['Brake pads', 'What oil should I use?', 'Will this fit my truck?']
  },
  {
    id: 'thanks',
    patterns: ['thanks', 'thank you', 'thx', 'appreciated', 'great thanks'],
    answer: 'You\'re welcome! If anything else comes up — a part to find or a question about your build — I\'m right here.',
    chips: ['Brake pads', 'Motor oil', 'Tonneau covers']
  },
  {
    id: 'goodbye',
    patterns: ['bye', 'goodbye', 'see you', 'good night', 'later'],
    answer: 'Goodbye! Good luck with the build — come back anytime you need parts.',
    chips: []
  }
];
